import { Controller } from '@hotwired/stimulus'

const formatter = new Intl.DateTimeFormat('en-GB', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  hour12: true,
  timeZone: 'UTC'
})

const minute = 60_000

export default class extends Controller {
  static targets = ['input', 'effectiveDate', 'priorEffectiveDate', 'archivedUntil']

  declare readonly inputTarget: HTMLInputElement
  declare readonly effectiveDateTarget: HTMLElement
  declare readonly priorEffectiveDateTarget: HTMLElement
  declare readonly archivedUntilTarget: HTMLElement

  declare readonly hasEffectiveDateTarget: boolean
  declare readonly hasPriorEffectiveDateTarget: boolean
  declare readonly hasArchivedUntilTarget: boolean

  connect (): void {
    this.update()
  }

  update (): void {
    if (this.hasEffectiveDateTarget) {
      const date = new Date(this.inputTarget.value)
      this.effectiveDateTarget.textContent = this.formatLong(date)
    }

    if (this.hasPriorEffectiveDateTarget) {
      const date = new Date(this.inputTarget.value)
      const prev = new Date(date.getTime() - minute)
      this.priorEffectiveDateTarget.textContent = this.formatLong(prev)
    }

    if (this.hasArchivedUntilTarget) {
      const period = parseInt(this.inputTarget.value)

      if (isNaN(period) || period <= 0) {
        this.archivedUntilTarget.parentElement?.classList.add('hidden')
      } else {
        this.archivedUntilTarget.parentElement?.classList.remove('hidden')

        const now = new Date()
        const archivedUntil = new Date(now.setMonth(now.getMonth() + period))
        this.archivedUntilTarget.textContent = this.formatShort(archivedUntil)
      }
    }
  }

  private formatShort (d: Date): string {
    return formatter
      .format(d)
      .replace(/,.*/g, ' ')
  }

  private formatLong (d: Date): string {
    return formatter
      .format(d)
      .replace(/, /g, ' ')
      .replace(/\b(?:am|pm)\b/g, m => m.toUpperCase())
  }
}
